import type { ComponentType } from 'react';
import { Hueco } from '../componentes/EstadoPagina';
import type { NombreIcono } from '../componentes/iconos';
import { Segmentos } from '../componentes/Segmentos';
import { dibujoDe } from '../marco/iconosMenu';
import { valorDeApartado } from './apartados';
import type { PropsPantalla } from './tipos';
import '../componentes/apartado.css';

/**
 * Pantalla madre que solo pinta la barra de apartados (RV Segmentos) que manda el servidor (G130, G141): las entradas
 * con `parent_key` de la madre y `nested_as: section`, en su orden y solo si la persona tiene su permiso; cada una en
 * `?apartado=` (la ruta de su entrada). Sin `?apartado=`, la primera que llega. Las únicas cifras son las `badge` del
 * servidor. Como `pagos/Pagos.tsx`, para las madres sin contenido propio («Avisos» y «Mensajes», 5.1 a 5.5).
 */
interface Props extends PropsPantalla {
    /** Prefijo de las claves de sus apartados (`avisos_`). */
    prefijo: string;
    seccion: string;
    icono: NombreIcono;
    apartados: Readonly<Partial<Record<string, ComponentType<PropsPantalla>>>>;
    cortas?: Readonly<Record<string, string>>;
}

export function ConApartados({ prefijo, seccion, icono, apartados: componentes, cortas = {}, ...props }: Props) {
    const { busqueda, ruta, navegar, movil } = props;
    const apartados = (props.anidadas ?? [])
        .filter((e) => e.anidadaComo === 'section' && !e.noContratada)
        .map((e) => ({ clave: e.clave, etiqueta: e.etiqueta, corta: cortas[e.clave], icono: dibujoDe(e.icono), valor: valorDeApartado(e.clave, e.ruta, prefijo), ruta: e.ruta, cifra: e.contador }));
    const pedido = busqueda.get('apartado');
    const activo = apartados.find((a) => a.valor === pedido) ?? apartados[0];

    if (activo === undefined) {
        return <Hueco seccion={seccion} icono={icono} />;
    }
    const Apartado = componentes[activo.clave];

    return (
        <div className="rv-en-pantalla">
            {apartados.length > 1 && (
                <div className="rv-en-barra">
                    <Segmentos
                        etiqueta={`Apartados de ${seccion.toLocaleLowerCase('es')}`}
                        movil={movil}
                        items={apartados.map((a) => ({ etiqueta: a.etiqueta, corta: a.corta, icono: a.icono, cifra: a.cifra }))}
                        valor={apartados.indexOf(activo)}
                        onCambio={(i) => {
                            const a = apartados[i];
                            if (a !== undefined) {
                                navegar(a.ruta.includes('?') ? a.ruta : `${ruta}?apartado=${encodeURIComponent(a.valor)}`);
                            }
                        }}
                    />
                </div>
            )}
            {Apartado === undefined ? <Hueco seccion={activo.etiqueta} icono={activo.icono} /> : <Apartado key={activo.clave} {...props} />}
        </div>
    );
}
